export default function OperationLogPage() {
  return (
    <div className="space-y-5 max-w-[1440px] mx-auto">
      <h1 className="text-xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
        操作紀錄
      </h1>
      <div className="bg-background-50 border border-background-200 rounded-xl p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
          <i className="ri-file-list-line text-primary-500 text-2xl" />
        </div>
        <h2 className="text-lg font-semibold text-foreground-900 mb-2">操作紀錄</h2>
        <p className="text-sm text-foreground-500">此頁面將顯示系統所有操作日誌、登入紀錄與資料變更追蹤</p>
      </div>
    </div>
  );
}